import { z } from 'zod';

export const paywallSocialProofResponse = z.object({
  activeReaders: z.object({
    countryCode: z.string().length(2).nullable(),
    count: z.number().int().nonnegative(),
  }),
});
export type PaywallSocialProof = z.infer<typeof paywallSocialProofResponse>;

export const PAYWALL_SOCIAL_PROOF_CONFIG = {
  activeWindowHours: 24,
  activeReaderEvents: ['Open Story', 'Finished Reading Episode'],
  minCountryActiveReaders: 10_000,
} as const;

/** Shown only until the first served counts arrive; the app keeps the last served counts after that. */
export const PAYWALL_SOCIAL_PROOF_FALLBACK: PaywallSocialProof = {
  activeReaders: { countryCode: null, count: 230_000 },
};
